import * as LucideIcons from 'lucide-react';

/**
 * Maps icon names to Lucide React icon components
 * @param {string} iconName - Name of the icon (e.g., "Sparkles", "Heart")
 * @param {object} props - Props to pass to the icon component (size, color, etc.)
 * @returns {JSX.Element} The icon component
 */
export const getIcon = (iconName, props = {}) => {
  const IconComponent = LucideIcons[iconName];
  
  if (!IconComponent) {
    // Fallback to Star icon if not found
    return <LucideIcons.Star {...props} />;
  }
  
  return <IconComponent {...props} />;
};

export default getIcon;
